import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";

export const GetActivitiesBIZwebhook = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getActivitiesBIZwebhook(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_ACTIVITIES_BIZ_WEBHOOK, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};